module.exports = __webpack_public_path__ + "img/83.6.CODm.79558697.png";